import React from 'react';
import { Card, Steps } from 'antd';

const { Step } = Steps;

export default function SetupSteps({ step }) {
  return (
    <Steps className="setup-steps" current={step - 1}>
      <Step title="О компании" />
      <Step title="Настройки сервера" />
      <Step title="Настройка SMTP" />
    </Steps>
  );
}
